/**
 * The studio's player fetches slide JSON and narration from the signed workspace CDN, which
 * answers 403 without the project cookie — and both CDNs mark that 403 immutable for a year,
 * so a request that beats the cookie poisons the browser cache. useWorkspaceCdnSession
 * registers its acquisition here; the studio waits on it (capped) before loading the player.
 */
const pending = new Map<string, Promise<void>>();

export function markWorkspaceCdnPending(conversationId: string, acquisition: Promise<unknown>): void {
  pending.set(conversationId, acquisition.then(() => undefined, () => undefined));
}

export function whenWorkspaceCdnReady(conversationId: string, capMs = 3000): Promise<void> {
  const p = pending.get(conversationId);
  if (!p) return Promise.resolve();
  return Promise.race([p, new Promise<void>(r => setTimeout(r, capMs))]);
}
